import type { Api } from "../api";
import { LinksApi } from "./api";
import { MalakhLink } from "./malakh";
import { PeniellyLink, type PeniellyOptions } from "./penielly";
import { QueravelLink } from "./queravel";

export * from "./actions";
export * from "./api";
export * from "./assistant";
export * from "./malakh";
export * from "./penielly";
export * from "./queravel";

/** All three links for one signed-in client. */
export class Links {
  readonly api: LinksApi;
  readonly penielly: PeniellyLink;
  readonly malakh: MalakhLink;
  readonly queravel: QueravelLink;

  constructor(
    api: Api,
    private readonly opts: { penielly?: PeniellyOptions; chatId?: string } = {},
  ) {
    this.api = new LinksApi(api, opts.chatId);
    this.penielly = new PeniellyLink(this.api, opts.penielly);
    this.malakh = new MalakhLink(this.api);
    this.queravel = new QueravelLink(this.api);
  }

  /**
   * The links as used from one chat. The server refuses an app the chat's admins turned off,
   * such as Queravel in a space that switched it off for its channels.
   */
  inChat(chatId: string): Links {
    return new Links(this.api.api, { ...this.opts, chatId });
  }
}
